import { render } from "./PickingPacking.vue?vue&type=template&id=08c1dc09&scoped=true"
import script from "./PickingPacking.vue?vue&type=script&lang=js"
export * from "./PickingPacking.vue?vue&type=script&lang=js"

import "./PickingPacking.vue?vue&type=style&index=0&id=08c1dc09&scoped=true&lang=css"
import "./PickingPacking.vue?vue&type=style&index=1&id=08c1dc09&lang=css"

import exportComponent from "/home/dyam/Documentos/ENSI/mi-stock-ensi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c1dc09"]])

export default __exports__